/**
 * KB-META
 * Purpose: Menu help service
 * Role: ui.service
 * EntryPoints: constructor(), getCategoryTooltip(), getItemTooltip(), getMarkdownForCategory()
 * Inputs: private http:HttpClient; bucket:string; key:string
 * Outputs: 
 * Validation: 
 * Dependencies: HttpClient
 * Contracts: 
 * Auth&Privacy: auth:none; hipaa:none; pii:none
 * Observability: 
 * Router: shard=partner-portal-cura; H2=services/menu-help.service; tags=ui
 * Owner: ; LastReviewed: 2025-08-25
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';

type HelpIndex = {
	categories: Record<string, { tooltip: string; md?: string }>; // bucket label -> help
	items: Record<string, { tooltip: string; md?: string }>; // menuKey -> help
};

@Injectable({ providedIn: 'root' })
export class MenuHelpService {
	private index$!: Observable<HelpIndex>;

	constructor(private http: HttpClient) {
		// Initialize after http is assigned to avoid TS2729 (used before initialization)
		this.index$ = this.http.get<HelpIndex>('assets/help/nav/index.json').pipe(shareReplay(1));
	}

	getCategoryTooltip(bucket: string) {
		return this.index$.pipe(map(ix => ix.categories[bucket]?.tooltip ?? ''));
	}
	getItemTooltip(key: string) {
		return this.index$.pipe(map(ix => ix.items[key]?.tooltip ?? ''));
	}
	getMarkdownForCategory(bucket: string) {
		return this.index$.pipe(map(ix => ix.categories[bucket]?.md ?? ''));
	}
	getMarkdownForItem(key: string) {
		return this.index$.pipe(map(ix => ix.items[key]?.md ?? ''));
	}
	loadMarkdown(url: string): Observable<string> {
		return this.http.get(url, { responseType: 'text' });
	}
}


